import { capitalizarPrimeiraLetra } from '@/shared/utils/text';

import type { GrupoMarcosDoDia, MarcoNegociacao } from '../types/negociacaoMarcoTypes';

const FUSO = 'America/Sao_Paulo';

const formatadorData = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: FUSO,
});

const formatadorHora = new Intl.DateTimeFormat('pt-BR', {
  hour: '2-digit',
  minute: '2-digit',
  timeZone: FUSO,
});

const formatadorDia = new Intl.DateTimeFormat('pt-BR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: FUSO,
});

const formatadorChaveDia = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: FUSO,
});

function paraData(iso: string): Date | null {
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? null : data;
}

export function dataDoMarco(iso: string): string {
  const data = paraData(iso);
  return data ? formatadorData.format(data) : '—';
}

export function horaDoMarco(iso: string): string {
  const data = paraData(iso);
  return data ? formatadorHora.format(data) : '';
}

export function agruparMarcosPorDia(items: MarcoNegociacao[]): GrupoMarcosDoDia[] {
  const grupos: GrupoMarcosDoDia[] = [];

  for (const marco of items) {
    const data = paraData(marco.dataHora);
    const chave = data ? formatadorChaveDia.format(data) : 'sem-data';
    const rotulo = data ? formatadorDia.format(data) : 'Data não informada';
    const grupoAtual = grupos.at(-1);

    if (grupoAtual?.chave === chave) {
      grupoAtual.items.push(marco);
    } else {
      grupos.push({
        chave,
        rotulo: capitalizarPrimeiraLetra(rotulo),
        items: [marco],
      });
    }
  }

  return grupos;
}
